// 纯常量，不依赖 shepherd.js，可被任意模块导入而不触发 shepherd 加载

export const SYSTEM_TOUR_SHOWED_KEY = 'system_tour_showed';
export const AUTH_TOUR_SHOWED_KEY = 'auth_tour_showed';
export const NO_PROMOTION_CODE = 'no_promotion_code';

export const MODAL_IMG_CLS = 'shepherd-modal-place';
export const QUICK_JUMPER_CLS = 'shepherd-quick-jumper';

export const TOUR_EVENTS = {
  next: 'next',
  prev: 'prev',
  jump: 'jump',
  cancel: 'cancel'
};

export enum Tours {
  AUTH = 'auth',
  CHAT = 'chat',
  HISTORY = 'history',
  AGENT = 'agent',
  REPORT = 'report'
}

export const TOUR_LIST = [
  { key: Tours.CHAT, title: '查看对话消息', url: '/chat' },
  { key: Tours.HISTORY, title: '查看历史对话', url: '/history' },
  { key: Tours.AGENT, title: '管理客服账号', url: '/setting/team/agent' },
  { key: Tours.REPORT, title: '查看数据', url: '/report/overview' }
];

const getStepsCls = (key: Tours, step: number) =>
  Array(step)
    .fill(0)
    .map((_, index) => `laigu-tour-guide-${key}-${index}`);

const AUTH_STEP_COUNT = 2;
const CHAT_STEP_COUNT = 3;
const HISTORY_STEP_COUNT = 4;
const AGENT_STEP_COUNT = 3;
const REPORT_STEP_COUNT = 1;

export const AUTH_STEPS_CLS = getStepsCls(Tours.AUTH, CHAT_STEP_COUNT);
export const CHAT_STEPS_CLS = getStepsCls(Tours.CHAT, CHAT_STEP_COUNT);
export const HISTORY_STEPS_CLS = getStepsCls(Tours.HISTORY, HISTORY_STEP_COUNT);
export const AGENT_STEPS_CLS = getStepsCls(Tours.AGENT, AGENT_STEP_COUNT);
export const REPORT_STEPS_CLS = getStepsCls(Tours.REPORT, REPORT_STEP_COUNT);
